<template>
    <v-dialog v-model="showPopup" persistent :width="600">
        <div class="common-popup-container">
            <div class="popup-header">

                <div class="header-left">
                    <button v-if="index > 0" class="back-btn" @click="goback">
                        <img :src="require('@/assets/icons/back-arrow.svg')" alt="Back">
                    </button>
                    <h2 class="popup-title">{{ current.title }}</h2>
                </div>
                <span class="step-counter">{{ index + 1 }}/{{ content.length }}</span>
            </div>

            <p class="popup-subtitle" v-html="formattedSubtitle"></p>

            <div class="tutorial-image">
                <img v-if="current.image" :src="current.image" alt="" class="popup-image" />
            </div>

            <div class="popup-actions" :class="{ 'get-started': index === 6 }">
                <button v-if="current.buttons.skip" variant="text" class="skip-btn" @click="skip">
                    {{ current.buttons.skip }}
                </button>

                <button v-if="current.buttons.next" color="primary" class="next-btn" @click="next">
                    {{ current.buttons.next }}
                </button>
            </div>
        </div>
    </v-dialog>
</template>


<script>
import popupContent from '../EducationalPopups/PopupContent'

export default {
    name: 'TutorialPopup',
    props: {
        modelValue: {
            type: Boolean,
            required: true
        }
    },
    emits: ['update:modelValue'],
    data() {
        return {
            index: 0,
            content: popupContent
        }
    },
    computed: {
        showPopup: {
            get() {
                return this.modelValue
            },
            set(value) {
                this.$emit('update:modelValue', value)
            }
        },
        current() {
            return this.content[this.index]
        },
        formattedSubtitle() {
            const subtitle = this.current.subtitle;

            if (subtitle.includes('Create')) {
                return subtitle.replace(/\bCreate\b/g, '<strong>Create</strong>');
            }

            if (subtitle.includes('Dynamic Intelligence')) {
                return subtitle.replace(/\bDynamic Intelligence\b/g, '<strong>Dynamic Intelligence</strong>');
            }

            return subtitle;
        }
    },

    methods: {

        skip() {
            this.showPopup = false
            this.index = 0
        },
        next() {
            if (this.index < this.content.length - 1) {
                this.index++
            } else {
                this.showPopup = false
                this.index = 0
            }
        },
        goback() {
            this.index -= 1

        }
    }
}

</script>

<style scoped>
.common-popup-container {
    display: flex;
    flex-direction: column;
    background-color: var(--secondary-font-color);
    border-radius: 12px;
    padding: 1em;
    font-family: 'Inter', sans-serif;
    gap: 16px;
    min-width: 500px;
}

.popup-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}

.header-left {
    display: flex;
    align-items: center;
    gap: 8px;

}

.popup-title {
    font-size: var( --header-font-size);
    font-weight: 600;
    align-items: start;
    font-family: 'OverpassMono';
}

.step-counter {
    font-size: var(--normal-font-size);
    color: var(--primary-font-color);
    font-weight: bold;
}

.popup-subtitle {
    font-size: 0.95rem;
    color: #555;
    text-align: left;
}

.popup-image {
    width: 100%;
    height: auto; 
    object-fit: contain;
}

.popup-actions {
    display: flex;
    justify-content: space-between;
    width: 100%;
    gap: 8px;

}

.get-started .next-btn {
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
    gap: 20px;
    background: var(--primary-gradient);
}

.skip-btn {
    width: 50%;
    padding: 8px;
    background: white;
    color: black;
    font-size: var(--normal-font-size);
    border: 1px solid black;
    border-radius: 8px;
}

.next-btn {
    width: 50%;
    padding: 8px;
    background: #262626;
    color: #FFF;
    font-size: var(--normal-font-size);
    border-radius: 8px;
}

.back-btn {
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1em;
    background-color: #FFFFFF;
    border: 1px solid #E5E5E5;
    border-radius: 50%;
}

.tutorial-image {
    border: 1px solid var(----light-grey-color);
    width: 100%;
    overflow: hidden;
}
</style>
